module.exports = __webpack_public_path__ + "media/images/Tiled-Church-montage-defocus-956e7a48ad19239f3c7ad4b8c0ea2457.png";